import React, { Component } from 'react';
/* eslint-disable */
import axios from 'axios';
import { MY_API_URL } from '../../Apanel/QueryMe';

const apiurl = MY_API_URL;
import { Card, CardBody, Col, Row, Badge } from 'reactstrap';
const initialstate = {
	tstats: [],
	token: localStorage.token,
};
class Dashboard extends Component {
	constructor(props) {
		super(props);
	}
	state = { ...initialstate };
	componentDidMount() {
		localStorage.setItem('gotodash', 0);
		if (localStorage.profile_completed === '0') {
			localStorage.setItem('came_from', 'dashboard');
			this.props.history.push({
				pathname: '/profile',
				backTo: '/',
			});
		} else {
			this.getCntTickts(localStorage.token);
		}
	}
	getCntTickts = (token) => {
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};
		var postData = {
			token: token,
			uid: localStorage.usercode,
			status: 'all',
		};
		const getuurl = apiurl + 'getCntTickts';
		axios
			.post(getuurl, postData, {
				headers: headers,
			})
			.then((response) => {
				console.log(response.data.data);
				if (response.data.error) {
				} else {
					this.setState({
						tstats: response.data.data,
					});
				}
			})
			.catch((error) => {
				localStorage.clear();
				this.props.history.push('/');
			});
	};
	render() {
		return (
			<Row>
				<Col md={4}>
					<Card>
						<CardBody>
							<div className="card__title">
								<h5 className="bold-text">New Tickets</h5>
							</div>
							<p>
								<Badge style={{ fontSize: '15px' }} color="danger">
									{this.state.tstats[0]}
								</Badge>
							</p>
						</CardBody>
					</Card>
				</Col>
				<Col md={4}>
					<Card>
						<CardBody>
							<div className="card__title">
								<h5 className="bold-text">Under Process Tickets</h5>
							</div>
							<p>
								<Badge style={{ fontSize: '15px' }} color="warning">
									{this.state.tstats[1]}
								</Badge>
							</p>
						</CardBody>
					</Card>
				</Col>
				<Col md={4}>
					<Card>
						<CardBody>
							<div className="card__title">
								<h5 className="bold-text">Replyed Tickets</h5>
							</div>
							<p>
								<Badge style={{ fontSize: '15px' }} color="warning">
									{this.state.tstats[2]}
								</Badge>
							</p>
						</CardBody>
					</Card>
				</Col>
				<Col md={3}>
					<Card>
						<CardBody>
							<div className="card__title">
								<h5 className="bold-text">Replyed by User </h5>
							</div>
							<p>
								<Badge style={{ fontSize: '15px' }} color="warning">
									{this.state.tstats[3]}
								</Badge>
							</p>
						</CardBody>
					</Card>
				</Col>
				<Col md={3}>
					<Card>
						<CardBody>
							<div className="card__title">
								<h5 className="bold-text">Closed by User</h5>
							</div>
							<p>
								<Badge style={{ fontSize: '15px' }} color="success">
									{this.state.tstats[4]}
								</Badge>
							</p>
						</CardBody>
					</Card>
				</Col>
				<Col md={3}>
					<Card>
						<CardBody>
							<div className="card__title">
								<h5 className="bold-text">Closed by Support</h5>
							</div>
							<p>
								<Badge style={{ fontSize: '15px' }} color="success">
									{this.state.tstats[5]}
								</Badge>
							</p>
						</CardBody>
					</Card>
				</Col>
				<Col md={3}>
					<Card>
						<CardBody>
							<div className="card__title">
								<h5 className="bold-text">Reopened </h5>
							</div>
							<p>
								<Badge style={{ fontSize: '15px' }} color="danger">
									{this.state.tstats[6]}
								</Badge>
							</p>
						</CardBody>
					</Card>
				</Col>
			</Row>
		);
	}
}

export default Dashboard;
